import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";


function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
    <div className="offcanvas-header border-bottom">
          <h5 className="m-0 drawer-title">YOUR SELECTION</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body d-flex flex-column">
          <div className="flex-grow-1 overflow-auto">
            {cartItems && cartItems.length ? (
            <>
            
            <div className="tf-mini-cart-sroll">
                    {cartItems && cartItems.length > 0 && (
                      <div className="tf-mini-cart-items">
                        {cartItems.map((item, index) => (
                          <CartItems key={item._id || index} item={item} />
                        ))}
                      </div>
                    )}
                  </div>
            </>
):
 (
            <div className="tf-mini-cart-wrap-blank">
              <div className="emptycart">
                <span>Your Shopping Cart is Empty</span>
              </div>

              <Link
                to="/shop"
                className="mt-3 tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
              >
                Shop Now
              </Link>
            </div>
          )
            }
            
          </div>
           <div className="tf-mini-cart-bottom-wrap">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="tf-cart-totall text-md fw-medium">
                      SubTotal:
                    </div>
                    <div className="tf-totals-total-value text-md fw-semibold">
                      ₹{cartSummary.subtotal}/-
                    </div>
                  </div>
                  {cartSummary.discount > 0 && (
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="cart-bottom-head text-md">
                        Discount:
                      </div>
                      <div className=" text-md fw-semibold">
                        - ₹{cartSummary.discount}/-
                      </div>
                    </div>
                  )}
                  <div className="d-flex align-items-center justify-content-between">
                    <div className=" text-md cart-bottom-head">
                      Shipping:
                    </div>
                    <div className="tf-totals-total-value text-md fw-semibold">
                      + ₹{cartSummary.shipping}/-
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className=" text-md cart-bottom-head">
                      Total:
                    </div>
                    <div className=" text-md fw-semibold">
                      ₹{cartSummary.total}/-
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <Link
                      className="w-100 checkout-btn "
                      to="/checkout"
                    >
                      <span>Check out</span>
                    </Link>
                    <Link
                      className="w-100 cart-btn"
                      to="/cart"
                    >
                      View cart
                    </Link>
                  </div>
                </div>
          {/* {cartItems.length > 0 && (
            <div className="border-top pt-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="text-uppercase small letter-spacing-2">Total</span>
                <span className="fs-5" style={{fontFamily: 'var(--font-serif)'}}>Rs.{total.toFixed(2)}</span>
              </div>
              <Link to="/cart">
              <button className="checkout-btn w-100 rounded-pill">Proceed to Checkout</button></Link>
            </div>
          )} */}
        </div>






      {/* --- CART DRAWER --- */}
    


    </>
  );
}

export default CartCanvas;
